import React, { FC, ReactNode, useEffect, useState } from "react";
import ActivityFrame from "../../../components/activity-frame/activity-frame";
import Breadcrumb from "../../../components/breadcrumb/breadcrumb";
import { TranslationKeys } from "../../../contexts/TranslationKeys";
import { useLocale } from "../../../contexts/localeContext";
import { Link, useHistory } from "react-router-dom";
import Tabs, { getTabsListFromLabels } from "../../../components/tabs/tabs";
import { Category } from "../../../models/Category";
import Restricted from "../../../contexts/PermissionProvider/RestrictedWrapper";
import plusIcon from "../../../images/Plus.svg";
import SecurityPoliciesTab from "../../../containers/security-policies-tab";
import { useTabCount } from "../../../hooks/useCategoryTab";
import { Filter } from "../../../models/Filter";
import { getListOfSiteIdsFromFilter } from "../../../utilities/tabUtils";

const SecurityPolicies: FC = () => {
    const [busy, setBusy] = useState(false);
    const { translate } = useLocale();
    const history = useHistory();
    const [categories, setCategories] = useState<Category[]>([{
        displayName: translate.byKey(TranslationKeys.securityPolicy),
        heading: translate.byKey(TranslationKeys.securityPolicy),
        value: "",
        id: 0,
        count: 1,
    }]);
    const [selected, setSelected] = useState(0);
    const [tabContent, setTabContent] = useState<ReactNode[]>([]);
    
    const { updateTabCount } = useTabCount({
        tableName: "Profile",
        pathToSite: "profile.site",
        categories,
        setCategories,
        customFilters: { 'profileType.id': "= 13", 'PHidden': "= 0" }
    });

    const onFilterChange = (filters: Filter[]) => {
        updateTabCount(getListOfSiteIdsFromFilter(filters));
    }

    useEffect(() => {
        if (categories.length > 0) {
            const newTabContent = [
                <SecurityPoliciesTab
                    setBusy={setBusy}
                    categories={categories}
                    setCategories={setCategories}
                    onFilterChange={onFilterChange} />
            ];
            setTabContent(newTabContent);
        }
    }, [categories]);
    
    return (
        <ActivityFrame busy={busy} className="flex flex-grow overflow-y-hidden">
            <div className="pt-4 pl-4 pb-4 flex flex-col flex-grow">
                <Breadcrumb
                    path={[ 
                        { 
                            value: "/access-control/configuration", 
                            displayName: translate.byKey(TranslationKeys.configuration), 
                            disableClick: true },
                        { 
                            value: "/access-control/configuration/security-polices", 
                            displayName: translate.byKey(TranslationKeys.securityPolicies) 
                        },
                    ]}
                    onClick={(item) => history.push(item.value)} />
                <Tabs
                    className="overflow-y-hidden"
                    tabs={getTabsListFromLabels(categories)}
                    onSelect={(i) => setSelected(i)}
                    selected={selected}
                    onAdd={() => {}}
                    add={false}
                    tabStyle={{}} >
                    {tabContent[selected]}
                    <div className="flex flex-col flex-grow overflow-y-hidden mb-viewport">
                        <div className="flex flex-row justify-end button-cluster">
                            <Restricted to={`add.security-policies.element`}>
                                <Link to={{ pathname: "/access-control/configuration/security-policy/" }}>
                                    <button className="flex rounded-lg bg-lime text-white p-2 shadow-lg" id="addSecurityPolicyButton">
                                        <img src={plusIcon} className="px-2 w-8 py-1" alt=""/>
                                        <span className="mr-2">{translate.byKey(TranslationKeys.add)}</span>
                                    </button>
                                </Link>
                            </Restricted>
                        </div>
                    </div>
                </Tabs>
            </div>
        </ActivityFrame>
    );
};

export default SecurityPolicies;
